import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAngularjsComponent } from './simple-icons-angularjs.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAngularjsComponent ],
    exports:      [ SimpleIconsAngularjsComponent ],
    bootstrap:    []
})
export class SimpleIconsAngularjsModule {}
